import gql from 'graphql-tag';

export const LISTING_SUMMARY_DETAILS_FRAGMENT = gql`
    fragment LISTING_SUMMARY_DETAILS_FRAGMENT on ListingData {
        administrationFees
        title
        displayAddress
        analyticsTaxonomy {
            section
        }
        embeddedContent {
            videos {
                url
            }
            tours {
                url
            }
            links {
                url
            }
        }
        content {
            floorPlan {
                original
            }
        }
        statusSummary {
            label
        }
        tags {
            label
        }
        counts {
            numBedrooms
            numBathrooms
            numLivingRooms
        }
        floorArea {
            unitsLabel
            value
        }
        pricing {
            label
            priceQualifierLabel
            rentFrequencyLabel
            isAuction
            pricePerFloorAreaUnit {
                internalValue
                unitsLabel
            }
            alternateRentFrequencyPrice {
                internalValue
                rentFrequencyLabel
            }
        }
        features {
            flags {
                availableFromDate
            }
        }
    }
`;
